import { Component, OnInit } from '@angular/core';
import { LocationService } from '../../../@core/services/location.service';
import { StopService } from '../../../@core/services/stop.service';

@Component({
  selector: 'route-postalcode',
  templateUrl: './route-postalcode.component.html',
  styleUrls: ['./route-postalcode.component.scss']
})
export class RoutePostalcodeComponent implements OnInit {
  // google maps zoom level
  zoom: number = 16;
  // initial center position for the map
  lat: number = 45.500922;
  lng: number = -73.443143;

  constructor(
    public _locationService: LocationService,
    public _stopService: StopService
  ) {}

  ngOnInit() {
    this.setCurrentLocation();
  }

  // Get Current Location Coordinates
  private setCurrentLocation() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.lat = position.coords.latitude;
        this.lng = position.coords.longitude;
        this.zoom = 15;
      });
    }
  }
}
